<div class="dialog">
  <div class="dialog__header customer-filter-dialog__header">
    <h1 class="dialog__title">表示条件</h1>
    <span class="close" (click)="close()"></span>
  </div>

  <div class="dialog__body customer-filter-dialog__body">
    <div
      *ngFor="let condition of draftConditions; let i = index; trackBy: trackByIndex"
      class="customer-filter-dialog__row"
    >
      <div class="customer-filter-dialog__label">
        {{ getDefinition(condition.key)?.label }}
      </div>

      <ng-container *ngIf="getDefinition(condition.key) as definition">
        <select
          *ngIf="definition.type === 'select'"
          class="select select--bg-gray select--small"
          [(ngModel)]="condition.value"
        >
          <option [ngValue]="null">選択してください</option>
          <option
            *ngFor="let option of definition.options || []"
            [ngValue]="option.value"
          >
            {{ option.label }}
          </option>
        </select>

        <input
          *ngIf="definition.type !== 'select'"
          class="customer-filter-dialog__input"
          [type]="definition.type === 'number' ? 'number' : 'text'"
          [(ngModel)]="condition.value"
        />
      </ng-container>
    </div>
  </div>

  <div class="dialog__footer customer-filter-dialog__footer customer-filter-dialog__actions">
    <button
      type="button"
      class="btn btn--small btn--blue"
      (click)="clearConditions()"
    >
      クリア
    </button>
    <button
      type="button"
      class="btn btn--blue btn--small"
      (click)="applyConditions()"
    >
      適用
    </button>
  </div>
</div>
